import * as ForgetPasswordStore from "./slices/forget-password";
import * as LoginStore from "./slices/login";
import * as ModalUpStore from "./slices/modal-popup";
import * as SignUpStore from "./slices/signup";
import * as UiStore from "./slices/ui";
import * as DateFilterStore from "./slices/date-filter";
import * as ClientStore from "./slices/client";
import * as RedemptionChannelStore from "./slices/redemption-channel";
import * as BranchUserStore from "./slices/users";
import * as ProductsStore from "./slices/products";
import * as LookupStore from "./slices/lookup";
import * as PointOfSaleStore from "./slices/point-of-sale";
import * as ProductItemStore from "./slices/product-item-details";
import * as InvoicesStore from "./slices/invoices";
import * as PowerBiStore from "./slices/power-bi";
import * as DashboardStore from "./slices/dashboard";
import * as BatchStore from "./slices/batches";
import * as ProductOperationsStore from "./slices/product-operations";

const reducers = {
  ui: UiStore.reducer,
  login: LoginStore.reducer,
  forgetPassword: ForgetPasswordStore.reducer,
  signup: SignUpStore.reducer,
  modalpopup: ModalUpStore.reducer,
  dateFilter: DateFilterStore.reducer,
  client: ClientStore.reducer,
  redemptionchannel: RedemptionChannelStore.reducer,
  user: BranchUserStore.reducer,
  products: ProductsStore.reducer,
  lookups: LookupStore.reducer,
  pointofsales: PointOfSaleStore.reducer,
  productitems: ProductItemStore.reducer,
  invoices: InvoicesStore.reducer,
  powerBi: PowerBiStore.reducer,
  dashboard: DashboardStore.reducer,
  batch: BatchStore.reducer,
  productoperations: ProductOperationsStore.reducer,
};

export { reducers };
